import {
  CorporationPositionSetupPage,
  CustomerSourceSetupPage,
  CustomerTypeSetupPage,
} from "src/container/Administration/Setups";

import SettingsLayout from "./SettingsLayout";
import { customersSettingsTabs } from "./settingsRoutes";

type CustomersSettingsTab = "type" | "source" | "position";

interface CustomersSettingsPageProps {
  tab: CustomersSettingsTab;
}

const customersSettingsContent = {
  type: <CustomerTypeSetupPage />,
  source: <CustomerSourceSetupPage />,
  position: <CorporationPositionSetupPage />,
};

const CustomersSettingsPage = ({ tab }: CustomersSettingsPageProps) => (
  <SettingsLayout titleKey="customers_settings" activeKey={tab} tabs={customersSettingsTabs}>
    {customersSettingsContent[tab]}
  </SettingsLayout>
);

export default CustomersSettingsPage;
